import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetShiftPlanOutputRequest, GetShiftPlanOutputResponse } from "../../pages/reviewAndPublish/model";
import { getShiftPlanOutput, publishShiftPlan } from "../../pages/reviewAndPublish/api";
import {showError} from "./errorSlice";

export interface ReviewAndPublishState {
    shiftPlanOutput?: GetShiftPlanOutputResponse
}

const initialState: ReviewAndPublishState = {
    shiftPlanOutput: undefined
}

export const getShiftPlanOutputThunk = createAsyncThunk<GetShiftPlanOutputResponse, GetShiftPlanOutputRequest>(
    'reviewAndPublish/getShiftPlanOutput',
    async (getShiftPlanOutputRequest: GetShiftPlanOutputRequest, { rejectWithValue }) => {
        try {
            console.log("Received call for getShiftPlanOutput for request: ", getShiftPlanOutputRequest);
            const response: GetShiftPlanOutputResponse = await getShiftPlanOutput(getShiftPlanOutputRequest);
            console.log("GetShiftPlanOutputResponse: ", response);
            return response;
        } catch (error) {
            console.error("Error fetching Shift Plan Output from API:", error);
            return rejectWithValue(error);
        }
    }
);

export const publishShiftPlanThunk = createAsyncThunk(
    'reviewAndPublish/publishPlan',
    async (planId: string, { dispatch, rejectWithValue }) => {
        try {
            console.log("Received call for publishShiftPlan for planId: ", planId);
            const response = await publishShiftPlan(planId);
            console.log("Publish shift plan response: ", response);
            return response;
        } catch (error) {
            console.log("Error publishing shift plan: ", error);
            dispatch(showError({
                title: "Failed to publish plan",
                message: "Unable to publish plan. Please try again."
            }));
            return rejectWithValue(error);
        }
    }
);

const reviewAndPublishSlice = createSlice({
    name: 'reviewAndPublish',
    initialState,
    reducers: {
        resetShiftPlanOutput: (state) => {
            state.shiftPlanOutput = undefined;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getShiftPlanOutputThunk.pending, (state) => {
                state.shiftPlanOutput = undefined;
            })
            .addCase(getShiftPlanOutputThunk.fulfilled, (state, action) => {
                state.shiftPlanOutput = action.payload;
            })
            .addCase(getShiftPlanOutputThunk.rejected, (state) => {
                state.shiftPlanOutput = undefined;
            })
    }
});

export const { resetShiftPlanOutput } = reviewAndPublishSlice.actions;
export default reviewAndPublishSlice.reducer;
